import React from 'react';
import { Card, Icon } from 'semantic-ui-react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { DyzioPrimaryButton } from 'dyzio-shared-components/lib/components/dyzio-buttons';

const isDeclined = status => status === 'DECLINED';

const bottomBlockStyle = {
  lineHeight: '47px',
};

const descriptionBlockStyle = {
  height: '40px',
};

const buttonsStyle = {
  width: '45%',
};

const PendingInvitation = ({
  id,
  campaign: { name: campaignName },
  createdDate,
  createdBy,
  onInvitationAccepted,
  onInvitationDeclined,
  status,
}) => (
  <Card>
    <Card.Content>
      <Card.Header>{campaignName}</Card.Header>
      <Card.Meta>created { moment(createdDate).format('Do MMM Y') }</Card.Meta>
    </Card.Content>
    <Card.Content>
      <Card.Description style={descriptionBlockStyle}>
        { createdBy } invited you to join { campaignName } campaign
      </Card.Description>
    </Card.Content>
    {
      isDeclined(status) &&
      <Card.Content extra style={bottomBlockStyle}>
        This invitation is declined.
      </Card.Content>
    }

    {
      !isDeclined(status) &&
      <Card.Content extra style={bottomBlockStyle}>
        <DyzioPrimaryButton
          hasIcon
          style={buttonsStyle}
          color="red"
          icon={<Icon name="close" />}
          label="Decline"
          onClick={() => onInvitationDeclined(id)}
        />
        <DyzioPrimaryButton
          hasIcon
          style={buttonsStyle}
          floated="right"
          color="green"
          icon={<Icon name="check" />}
          label="Accept"
          onClick={() => onInvitationAccepted(id)}
        />
      </Card.Content>
    }
  </Card>
);

PendingInvitation.propTypes = {
  id: PropTypes.string.isRequired,
  campaign: PropTypes.object.isRequired,
  createdDate: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  createdBy: PropTypes.string.isRequired,
  onInvitationAccepted: PropTypes.func.isRequired,
  onInvitationDeclined: PropTypes.func.isRequired,
};

export default PendingInvitation;



/** WEBPACK FOOTER **
 ** ./src/components/pending-invitation/index.js
 **/